<div *ngIf="product" class="dealer-acquisition-product">
  <a [routerLink]="product?.routerLink || { cxRoute: 'product', params: product } | cxUrl"
    class="dealer-acquisition-product-image-container" tabindex="-1">
    <cx-media [container]="product.images?.PRIMARY" format="product" [alt]="product.summary"></cx-media>
  </a>
  <div class="dealer-acquisition-product-info">
    <a [routerLink]="product.routerLink ? product.routerLink : ({ cxRoute: 'product', params: product } | cxUrl)"
      class="dealer-acquisition-product-name" [innerHTML]="product.sapMaterialNumber +  ' - ' + product.name"></a>
    <div *ngIf="product.purchasable" class="dealer-acquisition-product-price">
      <div class="dealer-acquisition-product-price-container"
        [attr.aria-label]="'productDetails.productPrice' | cxTranslate" [class.mb-0]="product.bundleAvailable">
        {{ product.price?.formattedValue }}
        <span class="price-label">MSRP</span>
        <gen-info-price-wrapper [product]="product" [position]="TooltipPosition.Right"></gen-info-price-wrapper>
      </div>
      <a *ngIf="product.bundleAvailable"
        [routerLink]="{ cxRoute: 'bundles', params: { productCode: product.code, name: product.slug } } | cxUrl"
        class="buy-in-bundle call-for-pricing link cx-action-btn-link">
        Buy In Bundle >
      </a>
    </div>
    <div *ngIf="!product.purchasable" class="cx-product-price-container non-price">
      <div class="contact-us">
        Please contact us for pricing details.
      </div>
    </div>

    <gen-add-to-cart *ngIf="product.purchasable" [product]="product" [purchasable]="true" [productCode]="product.code"
      [showQuantity]="false"></gen-add-to-cart>

    <div *ngIf="!product.purchasable">
      <div class="position-relative" (mouseenter)="callForPricingMessage=tooltipMessage"
        (mouseleave)="callForPricingMessage=''">
        <a [href]="contactForPricingHref" class="call-for-pricing link cx-action-btn-link">
          Contact For Pricing
          <gen-info-message [message]="callForPricingMessage" [position]="'position-left'"></gen-info-message>
        </a>
      </div>
    </div>
  </div>
</div>